import { useState, createContext, useContext, ReactNode } from 'react';

export type SelectedLocation = string | undefined;

type FiltersProviderContextType = {
	selectedLocation: SelectedLocation;
	handleChangeLocation: (place: string) => void;
	handleClearLocation: () => void;
};

const FiltersProviderContext = createContext<
	FiltersProviderContextType | undefined
>(undefined);

export const FiltersProvider = ({ children }: { children: ReactNode }) => {
	const [selectedLocation, setSelectedLocation] =
		useState<SelectedLocation>(undefined);

	const handleChangeLocation = (place: string) => {
		setSelectedLocation(place);
	};

	const handleClearLocation = () => {
		setSelectedLocation(undefined);
	};

	return (
		<FiltersProviderContext.Provider
			value={{
				selectedLocation,
				handleChangeLocation,
				handleClearLocation
			}}
		>
			{children}
		</FiltersProviderContext.Provider>
	);
};

export const useFiltersContext = () => {
	const context = useContext(FiltersProviderContext);

	if (!context) {
		throw new Error(
			'useFiltersContext must be used within a <Filters.Root /> component'
		);
	}

	return context;
};
